module.exports = __webpack_public_path__ + "static/media/logo-pink.55395195.jpg";